var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"flexbox",staticClass:"view",class:{wrapped: _vm.wrapped}},[_vm._t("default",null,{"sideBySide":_vm.wrapped})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }